import _slicedToArray from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import { getList, getShareTmps, issueTmp, shareTmp, enableTmp, deleteTmp } from '@/api/template';
import Template from './components/template';
export default {
  name: "template-page",
  computed: {
    tenant: function tenant() {
      if (this.$store.state.cpscc.userInfo && this.$store.state.cpscc.userInfo.data2.tenant) {
        return this.$store.state.cpscc.userInfo.data2.tenant;
      }
      return '';
    }
  },
  data: function data() {
    return {
      userList: [],
      activeName: 'self',
      template: null,
      searchKey: '',
      selfTableData: [],
      publicTableData: [],
      loading: false,
      currentPage: 1,
      currentPage2: 1,
      total: 10,
      total2: 10,
      onlyReady: false
    };
  },
  methods: {
    copy: function copy() {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    shareDisable: function shareDisable(item) {
      var form = item.ctFrom;
      if (typeof form === 'string' && form !== '') {
        return form !== this.tenant;
      }
      return false;
    },
    enableHandle: function enableHandle(row, key) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _yield$_this$$awaitTo, _yield$_this$$awaitTo2, err;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this.$awaitTo(_this.$$confirm(row[key] ? '确定启用?' : '确定禁用?'));
            case 1:
              _yield$_this$$awaitTo = _context2.v;
              _yield$_this$$awaitTo2 = _slicedToArray(_yield$_this$$awaitTo, 1);
              err = _yield$_this$$awaitTo2[0];
              if (!err) {
                _context2.n = 2;
                break;
              }
              row[key] = !row[key];
              return _context2.a(2);
            case 2:
              _context2.n = 3;
              return enableTmp({
                TmpId: row.ctId,
                State: row[key]
              });
            case 3:
              _this.$message.success('修改成功');
              _this.getList();
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    switchHandle: function switchHandle(row, key) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var type, _yield$_this2$$awaitT, _yield$_this2$$awaitT2, err, handle;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              type = {
                ctIssue: row[key] ? '确定开启发布?' : '确定关闭发布?',
                ctShare: row[key] ? '确定开启共享?' : '确定关闭共享?'
              };
              _context3.n = 1;
              return _this2.$awaitTo(_this2.$$confirm(type[key]));
            case 1:
              _yield$_this2$$awaitT = _context3.v;
              _yield$_this2$$awaitT2 = _slicedToArray(_yield$_this2$$awaitT, 1);
              err = _yield$_this2$$awaitT2[0];
              if (!err) {
                _context3.n = 2;
                break;
              }
              row[key] = !row[key];
              return _context3.a(2);
            case 2:
              handle = {
                ctIssue: issueTmp,
                ctShare: shareTmp
              };
              _context3.n = 3;
              return handle[key]({
                TmpId: row.ctId,
                State: row[key]
              });
            case 3:
              _this2.$message.success('操作成功');
              _this2.getList();
            case 4:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    deleteTaskTmp: function deleteTaskTmp(row) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this3.$$confirm('确定删除?');
            case 1:
              _context4.n = 2;
              return deleteTmp({
                TmpId: row.ctId
              });
            case 2:
              _this3.$message.success('删除成功');
              _this3.getList();
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.getSelfTableData();
    },
    handleCurrentChange2: function handleCurrentChange2(page) {
      this.currentPage2 = page;
      this.getShareTableData();
    },
    toDetail: function toDetail(type, item) {
      var isCopy = type === 'copy';
      this.$router.push("/template/detail/".concat(type === 'create' ? '' : item.ctId).concat(isCopy ? '?isCopy=true' : ''));
    },
    create: function create(type, item) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _yield$_this4$$awaitT, _yield$_this4$$awaitT2, err;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this4.$awaitTo(_this4.$dialog(Template, {
                dialog: {
                  width: '700px',
                  title: type === 'edit' ? '编辑模板' : '新增模板',
                  appendToBody: false
                },
                props: {
                  id: type === 'edit' || type === 'copy' ? item.ctId : undefined,
                  isCopy: type === 'copy'
                }
              }, function (template) {
                _this4.template = template;
              }));
            case 1:
              _yield$_this4$$awaitT = _context5.v;
              _yield$_this4$$awaitT2 = _slicedToArray(_yield$_this4$$awaitT, 1);
              err = _yield$_this4$$awaitT2[0];
              _this4.template = null;
              if (!err) {
                _context5.n = 2;
                break;
              }
              console.log(err);
              return _context5.a(2);
            case 2:
              _this4.getList();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    },
    getSelfTableData: function getSelfTableData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var _yield$_this5$$awaitT, _yield$_this5$$awaitT2, err, data;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _this5.loading = true;
              _context6.n = 1;
              return _this5.$awaitTo(getList({
                combineSearch: _this5.searchKey ? "and/ctName-%".concat(_this5.searchKey) : '',
                page: _this5.currentPage,
                length: 10
              }));
            case 1:
              _yield$_this5$$awaitT = _context6.v;
              _yield$_this5$$awaitT2 = _slicedToArray(_yield$_this5$$awaitT, 2);
              err = _yield$_this5$$awaitT2[0];
              data = _yield$_this5$$awaitT2[1];
              _this5.loading = false;
              if (!err) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2);
            case 2:
              _this5.selfTableData = data.data1;
              _this5.total = data.data2;
            case 3:
              return _context6.a(2);
          }
        }, _callee6);
      }))();
    },
    getShareTableData: function getShareTableData() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var _yield$_this6$$awaitT, _yield$_this6$$awaitT2, err, data;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _this6.loading = true;
              _context7.n = 1;
              return _this6.$awaitTo(getShareTmps({
                combineSearch: _this6.searchKey ? "and/ctName-%".concat(_this6.searchKey) : '',
                page: _this6.currentPage2,
                length: 10
              }));
            case 1:
              _yield$_this6$$awaitT = _context7.v;
              _yield$_this6$$awaitT2 = _slicedToArray(_yield$_this6$$awaitT, 2);
              err = _yield$_this6$$awaitT2[0];
              data = _yield$_this6$$awaitT2[1];
              _this6.loading = false;
              if (!err) {
                _context7.n = 2;
                break;
              }
              return _context7.a(2);
            case 2:
              _this6.publicTableData = data.data1;
              _this6.total2 = data.data2;
            case 3:
              return _context7.a(2);
          }
        }, _callee7);
      }))();
    },
    getList: function getList() {
      this.getSelfTableData();
      this.getShareTableData();
    }
  },
  created: function created() {
    this.getList();
  }
};